import styled from 'styled-components/macro'
import { BREAK_ } from 'constants'
import { darken } from 'polished'

export const Label = styled.div`
  font-size: 20px;
  text-align: center;
  font-weight: 700;
  padding: 0 36px;
  ${BREAK_.md_dn} {
    font-size: 18px;
    padding: 0 15px;
  }
`

export const Main = styled.div`
  display: flex;
  gap: 8px;
  bottom: 24px;
  ${BREAK_.md_dn} {
    bottom: 60px;
  }
  right: 40px;
  align-items: center;
  justify-content: end;
  background: transparent;
`

export const InnerSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  pointer-events: ${({ disabled }) => disabled ? 'not-allowed' : 'auto'};
`

const getButtonBackground = (variant, clr, pin, type, isIsometry, isMobile) => {
  // if (type === "poly" && pin === 0 && isIsometry && !isMobile) {
  //   return "#ffffffbf"
  // }
  if (type === "poly" && pin === 0 && isIsometry) {
    return isMobile && variant === "primary"
      ? `${clr?.primary}`
      : clr?.buttons_text;
  }
  if (type === "mono" && pin === 0 && isIsometry) {
    return isMobile && variant === "secondary"
      ? "#ffffffbf"
      : `${clr?.primary}`;
  }
  return variant === "primary" ? `${clr?.primary}` : clr?.buttons_text;
}

const getButtonHoverBackground = (variant, clr, pin, type, isIsometry, isMobile) => {
  // if (type === "poly" && pin === 0 && isIsometry && !isMobile) {
  //   return "#FFF"
  // }
  // if (type === "poly" && pin === 0 && isIsometry) {
  //   return isMobile && variant === "primary"
  //     ? darken(0.04, clr?.primary)
  //     : "#ffffffbf";
  // }
  if (type === "mono" && pin === 0 && isIsometry) {
    return isMobile && variant === "secondary"
      ? "#ffffffbf"
      : darken(0.04, clr?.primary);
  }
  return variant === "primary" ? darken(0.04, clr?.primary) : "#ffffffbf";
}

const getArrowFill = (variant, clr, pin, type, isIsometry, isMobile, disabled) => {
  if (disabled) return "#FFF"
  if (type === "poly" && pin === 0 && isIsometry && !isMobile) {
    return "#000"
  }
  return "#FFF"
}

export const ArrowButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  gap: 10px;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  line-height: 1;
  user-select: none;
  border: none;
  transition: background-color 0.1s ease-in, border 0.1s ease-in, box-shadow 0.1s ease-in;
  background-color: ${({ variant, clr, pin, type, isIsometry, isMobile }) => 
    getButtonBackground(variant, clr, pin, type, isIsometry, isMobile)};

  ${BREAK_.md_up} {
    height: 40px;
  }

  &:hover {
    background-color: ${({ variant, clr, pin, type, isIsometry, isMobile }) => 
      getButtonHoverBackground(variant, clr, pin, type, isIsometry, isMobile)};
    
    svg {
      fill: ${({ variant, clr, pin, type, isIsometry, isMobile, disabled }) => 
        getArrowFill(variant, clr, pin, type, isIsometry, isMobile, disabled)};
    }
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`

export const Section = styled.div`
  display: flex;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid ${({ clr, pin, isMobile, isIsometry, type }) => 
    pin === 0 && type === "poly" && isIsometry ? (isMobile ? `${clr?.primary}` : `#fff`) : `${clr?.primary}`};
  background: ${({ clr, pin, isMobile, isIsometry, type }) => 
    pin === 0 && type === "poly" && isIsometry ? (isMobile ? `${clr?.primary}bf` : `#ffffffbf`) : `${clr?.primary}bf`};
  justify-content: center;
  align-items: center;
  gap: 10px;
  line-height: 1;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  user-select: none;
  pointer-events: auto;
  opacity: ${({ disabled }) => disabled ? 0.5 : 1};
`
